import { Link } from "react-router-dom";
import { Phone, MessageCircle, MapPin } from "lucide-react";
import { PHONE_TEL, PHONE_DISPLAY, waLink } from "../lib/contact";

export const Footer = () => (
  <footer data-testid="site-footer" className="grain-overlay wood-ring bg-anthracite text-cream">
    <div className="relative z-[2] mx-auto max-w-7xl px-5 py-16 sm:px-8 lg:py-20">
      <div className="grid gap-12 lg:grid-cols-12">
        <div className="lg:col-span-5">
          <img
            src="/assets/logo-light.png"
            alt="LOGITEH PROD · Mobilă din viitor"
            className="h-12 w-auto"
          />
          <p className="mt-6 max-w-sm text-sm leading-relaxed text-cream/60">
            Atelier de tâmplărie și mobilier personalizat din lemn masiv, MDF și PAL.
            De la idee la montaj, exact pe dimensiunile spațiului tău.
          </p>
        </div>

        <div className="lg:col-span-3">
          <h3 className="font-mono text-xs uppercase tracking-[0.3em] text-oak">Linkuri rapide</h3>
          <ul className="mt-5 space-y-3 text-sm">
            {[
              { to: "/", label: "Acasă" },
              { to: "/servicii", label: "Servicii" },
              { to: "/portofoliu", label: "Portofoliu" },
              { to: "/contact", label: "Contact & Ofertă" },
            ].map((l) => (
              <li key={l.to}>
                <Link
                  to={l.to}
                  data-testid={`footer-link-${l.label.toLowerCase().replace(/[^a-z]/g, "-")}`}
                  className="text-cream/70 transition-colors hover:text-oak"
                >
                  {l.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div className="lg:col-span-4">
          <h3 className="font-mono text-xs uppercase tracking-[0.3em] text-oak">Contact direct</h3>
          <a
            href={PHONE_TEL}
            data-testid="footer-phone-link"
            className="mt-5 flex items-center gap-3 font-serif text-2xl font-bold transition-colors hover:text-oak"
          >
            <Phone size={20} className="text-oak" /> {PHONE_DISPLAY}
          </a>
          <a
            href={waLink()}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="footer-whatsapp-link"
            className="mt-4 inline-flex items-center gap-2 rounded-full border border-[#25D366]/40 px-5 py-2.5 text-sm font-semibold text-[#25D366] transition-colors hover:bg-[#25D366] hover:text-anthracite"
          >
            <MessageCircle size={16} /> Scrie-ne pe WhatsApp
          </a>
          <p className="mt-6 flex items-start gap-2 text-sm text-cream/50">
            <MapPin size={16} className="mt-0.5 shrink-0 text-oak" />
            Brașov, str. Carierei nr. 127 · Responsabil execuție: Balcangiu Gabriel.
            Deservim Brașov și împrejurimile, cu transport și montaj asigurat de echipa noastră.
          </p>
        </div>
      </div>

      <div className="mt-14 flex flex-col items-start justify-between gap-3 border-t border-cream/10 pt-7 font-mono text-[11px] uppercase tracking-[0.2em] text-cream/40 sm:flex-row sm:items-center">
        <span data-testid="footer-copyright">© 2026 LOGITEH PROD. Toate drepturile rezervate.</span>
        <span>RO16098542 · J08/184/2004 · Lemn masiv • MDF • PAL</span>
      </div>
    </div>
  </footer>
);
